import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {Observable} from 'rxjs';

import {Calendar, Entry, Timezone, Schedule} from 'src/app/models';

@Injectable({
    providedIn: 'root'
})
export class SchedulesService {
    timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    constructor(public http: HttpClient) {
    }

    getSchedules(): Observable<Schedule> {
        return this.http.get<Schedule>(`/api/v1/schedule`);
    }

    getCalendar(id: number, year?: number, month?: number, timezone?: any): Observable<Calendar> {
        const tz = encodeURIComponent(timezone === null ? this.timezone : timezone);
        if (year != null && month != null) {
            return this.http.get<Calendar>(`/api/v1/schedule/calendar/group/${id}?year=${year}&month=${month}&timezone=${tz}`);
        } else if (year != null) {
            return this.http.get<Calendar>(`/api/v1/schedule/calendar/group/${id}?year=${year}&timezone=${tz}`);
        } else if (month != null) {
            return this.http.get<Calendar>(`/api/v1/schedule/calendar/group/${id}?month=${month}&timezone=${tz}`);
        } else {
            return this.http.get<Calendar>(`/api/v1/schedule/calendar/group/${id}?timezone=${tz}`);
        }
    }

    getScheduleByGroupID(id: number): Observable<Entry[]> {
        return this.http.get<Entry[]>(`/api/v1/schedule/group/${id}`);
    }

    createSchedule(newSchedule: any): Observable<Schedule> {
        return this.http.post<Schedule>(`/api/v1/schedule`, newSchedule);
    }

    deleteScheduleEntry(id: number): Observable<Schedule> {
        return this.http.delete<Schedule>(`/api/v1/schedule/entry/${id}`);
    }

    updateSchedule(updateSchedule: any): Observable<Schedule> {
        return this.http.put<Schedule>(`/api/v1/schedule`, updateSchedule);
    }

    getFinalSchedule(groupID: any, afterDate: any, beforeDate: any): Observable<Schedule> {
        return this.http.get<Schedule>(`/api/v1/schedule/final/${groupID}`);
    }

    getAllTimezones(): Observable<Timezone[]> {
        return this.http.get<Timezone[]>('/api/v1/schedule/timezones');
    }

    checkParticipantDurations(participants) {
        let totalDuration = 0;
        participants.forEach(participant => {
            totalDuration += participant.duration;
        });
        return totalDuration === 24;
    }
}
